// src/Layout.jsx
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebars";
import DataManagement from "./components/DataManagement";

export default function Layout() {
  const location = useLocation();
  const showDataManagement = location.pathname.startsWith("/map");

  return (
    <div style={{ display: "flex", minHeight: "100vh", position: "relative" }}>
      <Sidebar />
      <main style={{ flex: "1 1 auto", padding: "1rem" }}>
        <Outlet />
      </main>
      {showDataManagement && <DataManagement />}
    </div>
  );
}
